/* The studio's own photographs. They're placed rather than gridded — layered
   into the hero and run full-bleed between sections — so the work threads
   through the page instead of sitting in one boxed-off gallery. */
export const PLATES = {
  tall: "/studio/field-01.jpg",  // 1200x1600 portrait
  wide: "/studio/field-02.jpg",  // 1800x1200 landscape
  break: "/studio/field-03.jpg", // 1800x1200 landscape
};

export const ILLUSTRATIONS = {
  heroLine: "https://static.prod-images.emergentagent.com/jobs/c503affe-bc36-4a50-8319-27952288a97b/images/3c738258ab183062d0211fbf3162969babd3712165fa08e99e86c35da8477371.jpeg",
  mark: "https://static.prod-images.emergentagent.com/jobs/c503affe-bc36-4a50-8319-27952288a97b/images/d8a4d1d208ff0ab16befa4c022b73e89f8b9ae863c7724135627746f732b8bd9.jpeg",
};

export const DEMOS = [
  {
    slug: "sora-sushi",
    name: "SORA SUSHI",
    tag: "Hospitality / Luxury",
    blurb: "A dark, editorial omakase experience with full-screen visuals and reservation-first design.",
    cover: "https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#C7A15A",
  },
  {
    slug: "verdant-landscapes",
    name: "VERDANT LANDSCAPES",
    tag: "Local Services / Outdoor",
    blurb: "Earth-toned, vibrant imagery with an instant quote calculator and a living project gallery.",
    cover: "https://images.unsplash.com/photo-1743327811352-8f9b286f9c12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#4B6B3A",
  },
  {
    slug: "sparkle-shine",
    name: "SPARKLE & SHINE CO.",
    tag: "Service / Residential",
    blurb: "Fresh, bright and airy with instant booking, trust badges and glowing customer reviews.",
    cover: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#2E7DAF",
  },
];

export const SORA_IMAGES = {
  hero: "https://images.unsplash.com/photo-1531973968078-9bb02785f13d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  a: "https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  b: "https://images.unsplash.com/photo-1633478062482-790e3b5dd810?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  c: "https://images.pexels.com/photos/33712148/pexels-photo-33712148.jpeg?auto=compress&cs=tinysrgb&w=1000",
  d: "https://images.unsplash.com/photo-1512132411229-c30391241dd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const VERDANT_IMAGES = {
  hero: "https://images.unsplash.com/photo-1743327811352-8f9b286f9c12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  a: "https://images.unsplash.com/photo-1779565145536-ccdf57517151?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  b: "https://images.unsplash.com/photo-1749803915455-a7642520d0d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  c: "https://images.unsplash.com/photo-1698239343452-7f40e4b7849d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  d: "https://images.unsplash.com/photo-1750682916296-71e66f86171d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const SPARKLE_IMAGES = {
  hero: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  a: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  b: "https://images.pexels.com/photos/6466495/pexels-photo-6466495.jpeg?auto=compress&cs=tinysrgb&w=1000",
  c: "https://images.unsplash.com/photo-1528740561666-dc2479dc08ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  d: "https://images.pexels.com/photos/5998056/pexels-photo-5998056.jpeg?auto=compress&cs=tinysrgb&w=1000",
};
